<div class="jobcard-timers-widget" *ngIf="timers && timers.length > 0 && !hasOpenModal" [ngStyle]="getWidgetStyles()"
    [class.collapsed]="isCollapsed" [class.dragging]="isDragging">

    <!-- Header / Drag Handle -->
    <div class="widget-header" (mousedown)="onDragStart($event)">
        <div class="header-content">
            <div class="header-title">
                <daz-icon [name]="'clock'" [size]="'20px'" [color]="'#ffffff'"></daz-icon>
                <span>{{'bikeshop.workshop.active_timers.active_timers' | translate}}</span>
                <div class="timer-count">{{timers.length}}</div>
            </div>
            <div class="header-actions">
                <div class="keyboard-hint" *ngIf="!isCollapsed">
                    <small>{{'bikeshop.workshop.active_timers.shortcut_hide' | translate}}</small>
                </div>
                <button class="collapse-btn" (click)="toggleCollapse(); $event.stopPropagation()">
                    <daz-icon *ngIf="!isCollapsed" [name]="'chevron-down'" [size]="'20px'"
                        [color]="'#ffffff'"></daz-icon>
                    <daz-icon *ngIf="isCollapsed" [name]="'chevron-up'" [size]="'20px'" [color]="'#ffffff'"></daz-icon>
                </button>
            </div>
        </div>
    </div>

    <!-- Timers List -->
    <div class="timers-container" *ngIf="!isCollapsed">
        <div class="timer-item" *ngFor="let timer of timers; let last = last" [class.last]="last">
            <div class="timer-main">
                <div class="timer-clock" [ngClass]="{'over-duration': isTimerOverdue(timer)}">
                    <div class="clock-display">{{getDuration(timer.timerID)}}</div>
                    <div class="clock-label">{{'bikeshop.workshop.active_timers.elapsed' | translate}}</div>
                </div>
                <div class="timer-details" (click)="onOpenJobCard(timer, $event)">
                    <div class="job-info">
                        <div class="job-number"><span>#{{timer.jobCardID}}</span></div>
                    </div>

                    <div class="jobcard-info">
                        <div class="info-row">
                            <daz-icon [name]="'user'" [size]="'14px'" [color]="'#060931'"></daz-icon>
                            <span>{{timer.customerName}} {{timer.customerSurname}}</span>
                        </div>
                        <div class="info-row">
                            <daz-icon [name]="'cheveron-right-double'" [size]="'14px'" [color]="'#060931'"></daz-icon>
                            <span>{{timer.manufacturer}} {{timer.model}}</span>
                        </div>
                        <div class="info-row">
                            <daz-icon [name]="'clipboard-user'" [size]="'14px'" [color]="'#060931'"></daz-icon>
                            <span>{{timer.technicianName}}</span>
                        </div>
                        <div class="info-row">
                            <daz-icon [name]="'clock'" [size]="'14px'" [color]="'#060931'"></daz-icon>
                            <span>{{getDurationFormatted(timer.allocatedJobcardDuraton/60)}}</span>
                        </div>
                    </div>
                </div>
                <div class="timer-actions">
                    <hub-button *ngIf="timer.isPaused" [icon]="'play'" [style]="'lavendar-solid'"
                        [size]="'lg'" [disabled]="timer.starting" [loading]="timer.starting" (click)="onStartTimer(timer, $event)">
                    </hub-button>
                    <hub-button *ngIf="!timer.isPaused" [icon]="'pause'" [style]="'lavendar-solid'"
                        [size]="'lg'" [disabled]="timer.pausing || timer.stopping" [loading]="timer.pausing" (click)="onPauseTimer(timer, $event)">
                    </hub-button>
                    <hub-button [icon]="'stop'" [style]="'lavendar-solid'"
                        [size]="'lg'" [disabled]="timer.pausing || timer.stopping || timer.starting" [loading]="timer.stopping" (click)="onStopTimer(timer, $event)">
                    </hub-button>
                </div>
            </div>
        </div>

        <!-- Show Keyboard Hint at bottom when expanded -->
        <div class="widget-footer">
            <small>{{'bikeshop.workshop.active_timers.footer_shortcut_description' | translate}}</small>
        </div>
    </div>

    <!-- Collapsed State - Circular Button -->
    <div class="collapsed-button" *ngIf="isCollapsed" (mousedown)="onDragStart($event)">
        <daz-icon [name]="'clock'" [size]="'28px'" [color]="'#FFFFFF'"></daz-icon>
        <div class="active-count-badge" *ngIf="timers.length > 0">{{timers.length}}</div>
    </div>
</div>